(function () {
  const root = document.querySelector('[data-panchona-home]');
  if (!root) return;

  const header = root.querySelector('[data-home-header]');
  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 40);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const menu = root.querySelector('[data-home-menu]');
  const menuButton = root.querySelector('[data-menu-open]');
  const setMenu = (open) => {
    if (!menu || !menuButton) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  };
  menuButton?.addEventListener('click', () => setMenu(true));
  root.querySelectorAll('[data-menu-close]').forEach((element) => element.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

  const productTrack = root.querySelector('[data-product-track]');
  const productTabs = Array.from(root.querySelectorAll('[data-product-tab]'));
  const productCards = Array.from(root.querySelectorAll('[data-product-card]'));
  const setProductTab = (group) => {
    productTabs.forEach((tab) => {
      const active = tab.dataset.productTab === group;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    productCards.forEach((card) => { card.hidden = card.dataset.productGroup !== group; });
    if (productTrack) {
      productTrack.dataset.activeGroup = group;
      productTrack.scrollTo({ left: 0, behavior: 'smooth' });
    }
  };
  productTabs.forEach((tab) => tab.addEventListener('click', () => setProductTab(tab.dataset.productTab)));

  const demoCart = root.querySelector('[data-demo-cart]');
  const demoCartLines = root.querySelector('[data-demo-cart-lines]');
  const demoCartEmpty = root.querySelector('[data-demo-cart-empty]');
  const demoCartTotal = root.querySelector('[data-demo-cart-total]');
  const demoItems = new Map();
  const formatDemoMoney = (value) => `$${new Intl.NumberFormat('es-AR').format(value)}`;
  const setDemoCart = (open) => {
    if (!demoCart) return;
    demoCart.classList.toggle('is-open', open);
    demoCart.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  };
  const renderDemoCart = () => {
    if (!demoCartLines || !demoCartTotal || !demoCartEmpty) return;
    demoCartLines.textContent = '';
    let total = 0;
    let count = 0;
    demoItems.forEach((item, key) => {
      total += item.price * item.quantity;
      count += item.quantity;
      const line = document.createElement('article');
      line.className = 'phome-demo-cart__line';
      line.innerHTML = `<img src="${item.image}" alt=""><div><h3>${item.title}</h3><strong>${formatDemoMoney(item.price)}</strong><div class="phome-demo-cart__quantity"><button type="button" data-demo-change="-1" data-demo-key="${key}" aria-label="Restar una unidad">−</button><span>${item.quantity}</span><button type="button" data-demo-change="1" data-demo-key="${key}" aria-label="Sumar una unidad">+</button></div></div><button class="phome-demo-cart__remove" type="button" data-demo-remove="${key}">Eliminar</button>`;
      demoCartLines.appendChild(line);
    });
    demoCartEmpty.hidden = demoItems.size > 0;
    demoCartTotal.textContent = formatDemoMoney(total);
    const cartCount = root.querySelector('.phome-cart span');
    if (cartCount) cartCount.textContent = count;
  };
  root.querySelectorAll('[data-demo-add]').forEach((button) => button.addEventListener('click', () => {
    const key = `${button.dataset.demoTitle}-${button.dataset.demoPrice}`;
    const current = demoItems.get(key);
    demoItems.set(key, current ? { ...current, quantity: current.quantity + 1 } : {
      title: button.dataset.demoTitle,
      price: Number(button.dataset.demoPrice),
      image: button.dataset.demoImage,
      quantity: 1
    });
    renderDemoCart();
    setDemoCart(true);
  }));
  root.querySelector('.phome-cart')?.addEventListener('click', (event) => {
    if (!demoItems.size) return;
    event.preventDefault();
    setDemoCart(true);
  });
  root.querySelectorAll('[data-demo-cart-close]').forEach((button) => button.addEventListener('click', () => setDemoCart(false)));
  demoCartLines?.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-demo-remove]');
    if (removeButton) demoItems.delete(removeButton.dataset.demoRemove);
    const changeButton = event.target.closest('[data-demo-change]');
    if (changeButton) {
      const key = changeButton.dataset.demoKey;
      const item = demoItems.get(key);
      if (item) {
        item.quantity += Number(changeButton.dataset.demoChange);
        if (item.quantity <= 0) demoItems.delete(key);
      }
    }
    renderDemoCart();
  });
  renderDemoCart();

  root.querySelectorAll('[data-home-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'PREPARANDO…';
    try {
      await window.PanchonaDirectCheckout(new FormData(form), button, originalLabel);
    } catch (_) {
      button.textContent = 'INTENTÁ DE NUEVO';
      window.setTimeout(() => { button.textContent = originalLabel; button.disabled = false; }, 1800);
    }
  }));

  const routineButtons = Array.from(root.querySelectorAll('[data-routine-step]'));
  const routineImage = root.querySelector('[data-routine-image]');
  const routineVideo = root.querySelector('[data-routine-video]');
  const routineCaption = root.querySelector('[data-routine-caption]');
  routineButtons.forEach((button) => button.addEventListener('click', () => {
    routineButtons.forEach((item) => item.classList.toggle('is-active', item === button));
    const isVideo = button.dataset.routineMedia === 'video';
    if (routineImage) routineImage.hidden = isVideo;
    if (routineVideo) routineVideo.hidden = !isVideo;
    if (isVideo && routineVideo && button.dataset.routineSrc) {
      routineVideo.pause();
      routineVideo.src = button.dataset.routineSrc;
      routineVideo.load();
      routineVideo.play().catch(() => {});
    } else if (!isVideo && routineImage && button.dataset.routineSrc) {
      routineVideo?.pause();
      routineImage.src = button.dataset.routineSrc;
      routineImage.alt = button.dataset.routineText || '';
    }
    if (routineCaption) routineCaption.textContent = button.dataset.routineText || '';
  }));

  const reelVideos = Array.from(root.querySelectorAll('.phome-reels video'));
  root.querySelectorAll('[data-reel-toggle]').forEach((button) => button.addEventListener('click', async () => {
    const video = button.closest('article')?.querySelector('video');
    if (!video) return;
    reelVideos.forEach((other) => { if (other !== video) { other.pause(); const otherButton = other.closest('article')?.querySelector('[data-reel-toggle]'); if (otherButton) otherButton.textContent = '▶ VER'; } });
    if (video.paused) { try { await video.play(); button.textContent = 'Ⅱ PAUSA'; } catch (_) {} }
    else { video.pause(); button.textContent = '▶ VER'; }
  }));
  if ('IntersectionObserver' in window) {
    const reelObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.intersectionRatio < .25) {
        entry.target.pause();
        const button = entry.target.closest('article')?.querySelector('[data-reel-toggle]');
        if (button) button.textContent = '▶ VER';
      }
    }), { threshold: [0, .25] });
    reelVideos.forEach((video) => reelObserver.observe(video));
  }
})();
